import { render, staticRenderFns } from "./SendSave.vue?vue&type=template&id=08befc04&scoped=true&"
import script from "./SendSave.vue?vue&type=script&lang=js&"
export * from "./SendSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08befc04",
  null
  
)

export default component.exports